import { render } from "./ModalAdminPanelCompany.vue?vue&type=template&id=303570d4"
import script from "./ModalAdminPanelCompany.vue?vue&type=script&lang=js"
export * from "./ModalAdminPanelCompany.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__